import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DashboardLeaderboardMenuItem } from '../../dashboard.component';
import { LeaderboardService } from '../leaderboard.service';
import { GlobalLeaderboardBaseRow, GlobalLeaderboardNewVideosRow, GlobalLeaderboardTesRow, GlobalLeaderboardViewRow } from '../leaderboard-api-response.model';
import  * as countries from "i18n-iso-countries";
import * as en from "i18n-iso-countries/langs/en.json";
import { AppAnalyticsService } from 'src/app-analytics.service';

@Component({
    selector: 'app-global-leaderboard',
    templateUrl: './global-leaderboard.component.html',
    styleUrls: ['./global-leaderboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GlobalLeaderboardComponent implements OnInit {

  _dashboardLbType: DashboardLeaderboardMenuItem = 'views';
  @Input() 
  set dashboardLbType(value: DashboardLeaderboardMenuItem) {
    this._dashboardLbType = value;
    this.getCurrentLbData();
  }
  get dashboardLbType(): DashboardLeaderboardMenuItem {
    return this._dashboardLbType;
  }

  showHowToLink: boolean = false;
  isLoading: boolean = false;
  displayData: GlobalLeaderboardViewRow[] | GlobalLeaderboardNewVideosRow[] | GlobalLeaderboardTesRow[] = [];

  constructor(private lbService: LeaderboardService, private analyticService: AppAnalyticsService) {  
  }

  ngOnInit(): void {
    countries.registerLocale(en);
    this.getCurrentLbData();
  }

  async getCurrentLbData() {
    this.isLoading = true;

    try {
      if (this.dashboardLbType == 'views') {
        this.displayData = await this.lbService.getGlobalViewsLeaderboard();  
      } else if (this.dashboardLbType == 'videos') {
        this.displayData = await this.lbService.getGlobalNewVideoLeaderboard();
      } else if (this.dashboardLbType == 'tes') {
        this.displayData = await this.lbService.getGlobalTesLeaderboard();
      }  

      const user_records = (this.displayData as GlobalLeaderboardBaseRow[]).filter(d => d.user_id != null);
      this.showHowToLink = user_records.length == 0;
      
    } catch (error) {
      console.error(error);
    }
    
    this.isLoading = false;
  }

  didClickHowTo() {
    this.analyticService.log('dahsboard_leaderboard_how_to_button');
  }

  getAddressLine(data: GlobalLeaderboardViewRow | GlobalLeaderboardNewVideosRow | GlobalLeaderboardTesRow ) {
    const { city, state, country_code } = data;
    const country = countries.getName(country_code, 'en');

    if (!city && !state) {
      return country || '';
    }

    return [city, state].filter(Boolean).join(', ') || country || '';
  }


}
